module.exports = __webpack_public_path__ + "static/media/pedro-sanchez.c550d55a.png";